import { render, staticRenderFns } from "./Rule.Quick.Setup.vue?vue&type=template&id=58654db0&"
import script from "./Rule.Quick.Setup.vue?vue&type=script&lang=js&"
export * from "./Rule.Quick.Setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports